import { render, staticRenderFns } from "./_TransitionManifestButton.vue?vue&type=template&id=41af483e&scoped=true&"
import script from "./_TransitionManifestButton.vue?vue&type=script&lang=js&"
export * from "./_TransitionManifestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af483e",
  null
  
)

export default component.exports